// extracted by mini-css-extract-plugin
module.exports = {"wrap":"wrap__2oH7X","chart":"chart__2LI9C"};